export default "__VITE_ASSET__89bf75b0__"